"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9595],{

/***/ 59595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var CardIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
  displayName: "Card__CardIcon",
  componentId: "sc-om9z8h-0"
})(["& svg{margin:auto;}"]);

var Card = function Card(_ref) {
  var title = _ref.title,
      description = _ref.description,
      icon = _ref.icon;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
    display: "flex",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardIcon, {
      children: icon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
      flex: "60%",
      textAlign: "left",
      paddingLeft: "1rem",
      my: "auto",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.2rem",
        letterSpacing: "0.6px",
        lineHeight: "26px",
        marginBottom: "0.3rem",
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        letterSpacing: "0.2px",
        lineHeight: "20.8px",
        marginTop: "0!important",
        children: description
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Card);

/***/ })

}]);